import { createSelector } from "@ngrx/store";
import { MobileAppState } from "./mobile.app.store";
import { MobileAppSubpage, mobileAppSubpages } from "./mobile.data";

const router = (store: MobileAppState) => store.router.state

export const mobileAppSubpageReselector = createSelector(
  router,
  (router): MobileAppSubpage => {
    const [_, mainRoute, appId, subRoute ] = router.url.split("/").map(w => w.toLocaleLowerCase())
    // console.log({ mainRoute, appId, subRoute })
    return subRoute as MobileAppSubpage
  }
)